import { useSEO } from "../../hooks/useSEO";

const GDPR = () => {
  useSEO({
    title: "GDPR Compliance",
    description: "Your rights under the EU General Data Protection Regulation (GDPR) and UK GDPR when using TaxShift 2026.",
    path: "/gdpr",
    keywords: "gdpr, eu data rights, uk gdpr, data subject access request",
  });

  return (
    <div className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-mono uppercase text-[10px] tracking-[0.3em] text-muted-foreground mb-4 block">
          Compliance · GDPR · EU/UK
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3" data-testid="gdpr-title">
          GDPR &amp; UK-GDPR Rights
        </h1>
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-10 pb-6 border-b-2 border-foreground">
          Last updated: February 2026
        </p>
        <div className="font-body text-base leading-relaxed space-y-5 text-foreground/85">
          <p>
            If you are located in the European Economic Area (EEA), the United Kingdom, or
            Switzerland, you have specific rights regarding your personal data under the General
            Data Protection Regulation (GDPR) and the UK GDPR. TaxShift 2026 acts as a
            <strong> data controller</strong> for data you provide through this Service.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">Your rights</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Right to access</strong> — obtain confirmation of and a copy of your personal data.</li>
            <li><strong>Right to rectification</strong> — correct inaccurate or incomplete data.</li>
            <li><strong>Right to erasure</strong> ("right to be forgotten") — request deletion of your data in specific circumstances.</li>
            <li><strong>Right to restriction of processing</strong> — request we limit processing in certain cases.</li>
            <li><strong>Right to data portability</strong> — receive your data in a structured, commonly used, machine-readable format.</li>
            <li><strong>Right to object</strong> — object to processing based on legitimate interests, direct marketing, or profiling.</li>
            <li><strong>Right to withdraw consent</strong> — where processing is based on consent, you can withdraw it at any time.</li>
            <li><strong>Right to lodge a complaint</strong> with your national supervisory authority.</li>
          </ul>
          <h2 className="font-heading text-2xl font-semibold mt-8">Legal bases for processing</h2>
          <p>We rely on the following legal bases (Article 6 GDPR):</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Consent</strong> — for optional cookies, newsletter, analytics.</li>
            <li><strong>Legitimate interests</strong> — operating and securing the Service, measuring aggregate use.</li>
            <li><strong>Legal obligation</strong> — where compliance with law requires processing.</li>
          </ul>
          <h2 className="font-heading text-2xl font-semibold mt-8">How to exercise your rights</h2>
          <p>
            Send a written request to <strong>privacy@taxshift2026.com</strong> with the subject
            line "GDPR Request" and specify the right you wish to exercise. We will respond within
            30 days as required by Article 12(3).
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">International data transfers</h2>
          <p>
            Personal data may be transferred to and processed in the United States. For EU/UK
            transfers, we rely on Standard Contractual Clauses (SCCs) and/or the EU-U.S. Data
            Privacy Framework where applicable.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">Supervisory authorities</h2>
          <p>
            EU residents: contact your national Data Protection Authority. A directory is
            available at <em>edpb.europa.eu</em>. UK residents: the Information Commissioner's
            Office (ico.org.uk).
          </p>
        </div>
      </div>
    </div>
  );
};

export default GDPR;
